import React from 'react';
import { Link } from 'react-router-dom';
import './Footer.css';

const COLUMNS = [
  {
    title: '探索',
    links: [
      { label: '首页', to: '/' },
      { label: '游戏商店', to: '/store' },
      { label: '地图工坊', to: '/maps' },
      { label: '社区', to: '/community' },
    ],
  },
  {
    title: '创作',
    links: [
      { label: '发布作品', to: '/maps/new' },
      { label: '创作者中心', to: '/creator' },
      { label: '代码市场', to: '/code-market' },
      { label: '创作活动', to: '/activities' },
    ],
  },
  {
    title: '我的',
    links: [
      { label: '我的游戏库', to: '/library' },
      { label: '每日签到', to: '/daily' },
      { label: '成就中心', to: '/achievements' },
      { label: '等级权益', to: '/level-benefits' },
    ],
  },
  {
    title: '支持',
    links: [
      { label: '帮助与客服', to: '/customer-service' },
      { label: '问题反馈', to: '/feedback' },
      { label: '用户协议', to: '/rules' },
      { label: '隐私政策', to: '/privacy' },
    ],
  },
];

export default function Footer() {
  return (
    <footer className="footer">
      <div className="footer-inner">
        <div className="footer-top">
          <div className="footer-brand-col">
            <Link to="/" className="footer-brand" aria-label="无限世界首页">
              <span className="footer-logo-frame">
                <img src="/logo.png" alt="" className="footer-logo-img" />
              </span>
              <div className="footer-logo-text">
                <span className="footer-logo-main">无限世界</span>
                <span className="footer-logo-sub">INFINITE WORLD</span>
              </div>
            </Link>
            <p className="footer-desc">
              游戏创作、作品分享、社区交流与游玩，
              <br />
              在这里发现更多可能。
            </p>
            <p className="footer-slogan">创造无限可能</p>
          </div>

          <nav className="footer-cols" aria-label="页脚导航">
            {COLUMNS.map(col => (
              <div className="footer-col" key={col.title}>
                <h4>{col.title}</h4>
                {col.links.map(item => (
                  <Link key={item.label} to={item.to}>{item.label}</Link>
                ))}
              </div>
            ))}
          </nav>
        </div>

        <div className="footer-bottom">
          <p className="footer-copy">© 2026 无限世界</p>
          <div className="footer-meta">
            <a href="mailto:wxsjxqz@qq.com">官方邮箱 wxsjxqz@qq.com</a>
            <span className="footer-dot" aria-hidden="true">·</span>
            <span>V1.1.0</span>
          </div>
        </div>
      </div>
    </footer>
  );
}
